import React from "react";
//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store";
import { clearToDismissMessages } from "store/actions/utilActions";
//#endregion
//#region components
import NotFound from "components/error/notFound";
import { LoginContainer, ResetPasswordContainer } from "components/login";
import Company from "./company";
import GenericCompany from "./genericCompany";
import MonthlyReportEntry from "./monthlyReport";
import Root from "./root";
import { useFloatingMessages } from "components/common";
import { Route, Routes, useLocation } from "react-router-dom";
import { EULAView } from "components/eula";
import lazyWithReload from "utils/lazyWithReload";
//#endregion

const OnboardingContainer = lazyWithReload(() => import("components/onboarding/onboardingContainer"));
const OffboardingContainer = lazyWithReload(() => import("components/offboarding/offboardingContainer"));

const Index: React.FC = () => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const location = useLocation();
  const { closeMessage } = useFloatingMessages();
  const toDismissMessages = useSelector((store: AppState) => store.util.toDismissFloatingMessageKeys);
  React.useEffect(() => {
    toDismissMessages.forEach((message) => {
      closeMessage(message);
    });
    dispatch(clearToDismissMessages());
  }, [location]);

  return React.useMemo(
    () => (
      <Routes>
        <Route path="/Login" element={<LoginContainer />} />
        <Route path="/ResetPassword/:ticket" element={<ResetPasswordContainer />} />
        <Route
          path="/Onboarding"
          element={
            <React.Suspense fallback={null}>
              <OnboardingContainer />
            </React.Suspense>
          }
        />
        <Route
          path="/Onboarding/:inviteToken/*"
          element={
            <React.Suspense fallback={null}>
              <OnboardingContainer />
            </React.Suspense>
          }
        />
        <Route
          path="/Offboarding"
          element={
            <React.Suspense fallback={null}>
              <OffboardingContainer />
            </React.Suspense>
          }
        />
        <Route path="/MonthlyReports/:companyId/:id" element={<MonthlyReportEntry />} />
        <Route path="/MonthlyReports/:id" element={<MonthlyReportEntry />} />
        <Route path="/NotFound" element={<NotFound />} />
        <Route path="/EULA" element={<EULAView />} />
        <Route path="/Company/*" element={<GenericCompany />} />
        <Route path="/:company/*" element={<Company />} />
        <Route path="/" element={<Root />} />
      </Routes>
    ),
    []
  );
};

export default Index;
